module.exports = __webpack_public_path__ + "static/media/rsz_banner_slider3.6862db44.jpg";